import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(async (config) => {
  const accessToken = window.localStorage.getItem('accessToken');
  config.headers['Content-type'] = 'application/json';
  if (accessToken) {
    config.headers['Authorization'] = accessToken;
  }
  return config;
});

export const responseInterceptors = ({ resolve, reject }) => {
  if (typeof resolve === 'function' || typeof reject === 'function') {
    instance.interceptors.response.use(resolve, reject);
  }
};

export default instance;
